import React, { useEffect, useState } from 'react';
import NewForm from 'components/NewForm';
import PageDefault from 'components/PageDefault';
  // import SelectProfile from './SelectProfile';
// import "./style-form-user.scss";
import profileService from 'services/profile.service';
import companyService from 'services/company.service';
import MultiselectTwoSides from 'components/MultiselectTwoSides';
// import { useHistory } from 'react-router';
import usersService from 'services/users.service';
import { useSelector } from 'react-redux';
import { IRootReducer } from 'store/reducers';
import { IUserState } from 'store/user/user.interface';

interface IUser{
  id?:number;
  profile_id?:string;
  firstname?: string;
  lastname?: string;
  phone?: string;
  office?: string;
  email?: string;
  companies?:number[];
}

export default function Account(){
  // const [ data, setData] = useStateByRequest<IUser>(usersService,{profile_id:undefined},{params:{
  //   appends:"companies",
  //   fields:"email,firstname,lastname,alias,profile_id,id"
  // }});
  const [ data, setData ] = useState<IUser>({companies:undefined});
  const block = true;
  const [ profiles, setProfile ] = useState<any[]>([]);
  const [ companies, setCompanies ] = useState<any[]>([]);
  // const history = useHistory();
  const user = useSelector<IRootReducer,IUserState>(state => state.user);

  useEffect(()=>{
    profileService.get<any[]>({params:{
      fields:"id,name,profile_type_id"
    }}).then((data)=>{
      setProfile(data.map((item:any)=>({value:item.id,name:item.name,type:item.user_profile_type_id})))
    })
    companyService.get<any[]>({params:{
      fields:"id,name,internal_code,document"
    }}).then((data:any[])=>{
      setCompanies(data.map((item:any)=>{
        return ({
          label:item.name,
          value:item.id
        })
      }));
    });
    usersService.show(user.id,{params:{
      appends:"companies",
      fields:"email,firstname,lastname,alias,profile_id,id"
    }}).then((data)=>{
      setData(data);
    });
  },[user.id]);

  function renderSelectCompany(profile_id:string){
    let p = profiles.filter(item=>{
      return item.value === parseInt(profile_id);
    })[0];
    let type = p?p.type:0;
    
    switch(type){
      case 2:
        return (
          <NewForm title="Companies">
            <MultiselectTwoSides options={companies} 
            onChange={(values)=>{
              setData((old:any)=>({...old,companies:values}))
            }} 
            value={data.companies}
            disabled={block}
            />
          </NewForm>
        );
      case 3:
        return (
          <NewForm title="Company">
            <NewForm.Select title="Company" md="4" name="companies" state={{model:data, setModel:setData}} 
            options={[{value:"",name:"Selecione"},...companies.map(item=>({value:item.value,name:item.label}))]}
            disabled={block}/>
          </NewForm>
        );
      default:
        return "";
    }
  }

  return (
    <PageDefault title="Form User">
      <PageDefault.Title>Criar User</PageDefault.Title>
      <PageDefault.Content>
        {/* <SelectProfile/> */}
        <NewForm title="Dados do usuario">
          <NewForm.Input title="Nome" md="4" name="firstname" state={{model:data, setModel:setData}} disabled={block}/>
          <NewForm.Input title="Sobrenome" md="4" name="lastname" state={{model:data, setModel:setData}} disabled={block}/>
          <NewForm.Input title="Email" md="4" name="email" state={{model:data, setModel:setData}} disabled={block}/>
          <NewForm.Input title="Apelido" md="4" name="alias" state={{model:data, setModel:setData}} disabled={block}/>
          <NewForm.Select title="Profile" md="4" name="profile_id" state={{model:data, setModel:setData}} options={[{value:"",name:"Selecione"},...profiles]}
          onChange={()=>{
            setData((old:any)=>({...old,companies:undefined}))
          }} disabled={block}/>
        </NewForm>
        {renderSelectCompany(data.profile_id??"0")}
      </PageDefault.Content>
    </PageDefault>
  );
}